import { Typography } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { SimpleConfirmDialog } from '../../../components/dialogs/SimpleConfirmDialog';
import { useHolidayWarningDialogStyles } from './HolidayWarningDialog.styles';

export default function HolidayWarningDialog({ isOpen, onOk }) {
  const { styles } = useHolidayWarningDialogStyles();
  return (
    <SimpleConfirmDialog
      className={styles.holidayWarningDialog}
      buttonsClassName={styles.buttons}
      open={isOpen}
      onOk={onOk}
      okTextId="buttons.ok"
      subtitleId="book.newShipment.holiday.title"
      okButtonProps={{ size: 'large' }}
    >
      <Typography.Paragraph>
        <FormattedMessage
          id="shipmentDetail.serviceAdvisory.confirmDelivery"
          tagName="div"
        />
      </Typography.Paragraph>
      <Typography.Paragraph>
        <FormattedMessage id="shipmentDetail.serviceAdvisory.internationalOrder" />
      </Typography.Paragraph>
    </SimpleConfirmDialog>
  );
}
